module.exports={render:function (){var _vm=this;var _h=_vm.$createElement;var _c=_vm._self._c||_h;
  return _c('div', {
    staticClass: "box tab-box"
  }, [_c('div', {
    staticClass: "header"
  }, _vm._l((_vm.tabs), function(tab, i) {
    return _c('div', {
      staticClass: "tab-btn"
    }, [_vm._v("Tab btn: " + _vm._s(tab.label) + " " + _vm._s(i))])
  }), 0), _vm._v(" "), _vm._l((_vm.tabs), function(tab, i) {
    return [_vm._t('tab' + i + i)]
  })], 2)
},staticRenderFns: []}


//////////////////
// WEBPACK FOOTER
// ./~/vue-loader/lib/template-compiler?{"id":"data-v-26e45b3c","hasScoped":false}!./~/vue-loader/lib/selector.js?type=template&index=0!./src/components/TabBoxes.vue
// module id = 587
// module chunks = 1